import React, {useState, useEffect} from "react";
import {Container, Box, Grid, Card, Button, useMediaQuery} from "@material-ui/core";
import {InformedConsent} from "../../Components";
import html2canvas from "html2canvas";
import {useHistory} from "react-router-dom";
import {useAppDispatch} from "../../redux/store";
import { savePDF } from "../../redux/scheduleAppointment/scheduling.actions";
//if testing pdf:
import {jsPDF} from "jspdf";
import useWindowSize from "../../helpers/windowResizeHook";

const ImformedConsentPage = () => {
    let currentPath = window.location.search;
    const dispatch = useAppDispatch();
    const [canSubmit, setCanSubmit] = useState(false);
    const history = useHistory();

    const handleClick = () => {
        const input = document.getElementById("consentForm");
        let html = input.outerHTML;
        let iframe = document.createElement("iframe");
        iframe.style.width = "1024px";
        iframe.style.height = "70%";
        iframe.style.marginTop = "115px";
        iframe.style.opacity = "0";
        document.body.prepend(iframe);
        iframe.srcdoc = html;
        iframe.addEventListener("load", () => {
            html2canvas(iframe.contentWindow.document.body, {scale: 2}).then((canvas) => {
                const imgData = canvas.toDataURL("image/jpeg");
                const pdfData = JSON.stringify(imgData);
                dispatch(savePDF(pdfData));
                iframe.remove();
                history.push("/invoice?type=appointment");
            });
        });
        // history.push("/appConsent")
    };

    return(
        <Container maxWidth="md">
            <Box marginTop="115px" marginBottom="115px">
                <Grid container>
                    <Grid item md={12} xs={12}>
                        <Card variant="outlined" style={{padding: 20}}>
                            <InformedConsent id="consentForm" setCanSubmit={setCanSubmit}/>
                            {!currentPath.includes("?noheader") &&
                                <Button
                                    type="button"
                                	variant="outlined"
                                	color="primary"
                                	style={{float:"right", marginTop: 20}}
                                	disabled={!canSubmit}
                                	onClick={handleClick}
                                >
                                    Save & Continue
                                </Button>
                            }
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default ImformedConsentPage;
